import React from "react";
import BookForm from "./BookForm";
import { AiFillInfoCircle, AiOutlineArrowLeft } from "react-icons/ai";

import { RiDeleteBin6Line } from "react-icons/ri";
import TopNav from "../TopNav/TopNav";
// import Header from "../Header/Header";
import NewHeader from "../NewHeader/NewHeader";
import Footer from "../Footer/Footer";
import "./planAddress.css";

function planAddress2() {
  return (
    <>
      {/* <TopNav /> */}
      <NewHeader />
      <div className="planAddDiv">
        <div className="leftSIde">
          <div className="AddressHeaindg">
            <span className="leftArrow">
              <AiOutlineArrowLeft />
            </span>{" "}
            Add Address
          </div>
          <div className="warning">
            <AiFillInfoCircle />
            <span>Sample will be picked from the below address</span>
          </div>
          <div className="addressFormDiv">
            <form>
              <div className="forBorder">
                <div className="deletIcon">
                  {" "}
                  <RiDeleteBin6Line className="deletlogo" />
                </div>
                <label className="halfWidthinput">
                  <p>NAME</p>{" "}
                  <input type="text" placeholder="Enter Name"></input>
                </label>
                <label className="halfWidthinput">
                  <p>MOBILE NUMBER</p>{" "}
                  <input type="text" placeholder="Enter Mobile Number"></input>
                </label>
                <label className="halfWidthinput">
                  <p>PIN CODE</p>{" "}
                  <input type="text" placeholder="Enter Pin Code"></input>
                </label>
                <label className="fullWidthinput">
                  <p>HOUSE/FLAT NUMBER & BUILDING*</p>{" "}
                  <input
                    type="text"
                    placeholder="Enter House And Building"
                  ></input>
                </label>
                <label className="fullWidthinput">
                  <p>STREET NAME</p>{" "}
                  <input
                    type="text"
                    placeholder="Enter Street Name Or Landmark"
                  ></input>
                </label>
                <label className="halfWidthinput">
                  <p>BOOKING FOR</p>{" "}
                  <input
                    type="text"
                    placeholder="Eg. Self, Parents, Children"
                  ></input>
                </label>
              </div>
              <div className="addressBtn2">
                <button type="submit">SAVE ADDRESS</button>
              </div>
            </form>
          </div>
        </div>
        <div className="rightside_section">{/* <BookForm /> */}</div>
      </div>
      <Footer />
      <div className="floatingBooking">
        <div className="border-book">
          <div className="price">
            <span style={{ textDecoration: "line-through", color: "gray" }}>
              Rs. 899/-
            </span>{" "}
            <span className="PriceColor">Rs. 600/-</span>
          </div>
          <div className="discount">
            <span>Get 30% OFF</span>
          </div>
          <div className="New_bookNow">
            <span>BOOK</span>
          </div>
        </div>
      </div>
    </>
  );
}
export default { component: planAddress2 };
